import treatmentDefaultFragment from "../fragments/treatmentDefault";

const treatment1Query = `treatment1[]->
${treatmentDefaultFragment}     
`;

export default treatment1Query;
